import { CategoryType } from '@libs/trip-planner-interfaces';
import type { AppSvgIconType } from '@libs/ui';

export function getIconNameFromAutoCompleteSuggestionCategory(
  category: CategoryType
): AppSvgIconType {
  switch (category) {
    case CategoryType.Hotel:
      return 'bed';

    case CategoryType.Airport:
      return 'airplane';

    default:
      return 'locationMark';
  }
}
